module.exports = __webpack_public_path__ + "static/media/bfile-condominium.6a1e8d35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-condominium.svg
// module id = 99
// module chunks = 0